import { useFieldContext } from '../../contexts';

/**
 * A form field that registers with the form state but renders nothing.
 *
 * Use this when you need to track a value in form state that doesn't have
 * a visible UI component, but whose value is managed programmatically.
 *
 * @example
 * ```tsx
 * // Register hidden fields that are updated via callbacks
 * <form.AppField name="testVariationId">
 *   {(field) => <field.HiddenField />}
 * </form.AppField>
 *
 * // Later, update the value programmatically
 * form.setFieldValue('testVariationId', newValue);
 * ```
 */
export function HiddenField() {
  // Register the field with the form by accessing its context
  // This ensures the field is tracked in form state
  useFieldContext();

  return null;
}
